const baseX = require( 'base-x' );

const base62 = baseX( '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ' )

module.exports = {

  /**
   * @function encode encodes a string
   * @param {string} str the string to be encoded
   * @param {string} prefix a prefix to be added to the encoded string
   */
  encode( str, prefix ) {
    const e = base62.encode( Buffer.from( str, 'utf8' ) )
    return prefix ? prefix + e : e
  },

  /**
   * @function decode decodes an encoded string
   * @param {string} str the string to be decoded
   * @param {string} prefix prefix to be taken off the str before it is decoded 
   */
  decode( str, prefix ) {
    if ( prefix ) {
      str = str.substring( prefix.length )
    }
    return base62.decode( str ).toString( 'utf8' )
  }
}
